import { render, staticRenderFns } from "./SocialBlock.vue?vue&type=template&id=6c0964bf"
import script from "./SocialBlock.vue?vue&type=script&lang=js"
export * from "./SocialBlock.vue?vue&type=script&lang=js"
import style0 from "./SocialBlock.vue?vue&type=style&index=0&id=6c0964bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports